<template>
  <div class="scanning-code ">
    <div
        style="position: fixed;height: 70px;background: #f0f2f5;width: 100%;z-index: 999;box-shadow:0 1px 6px 0 rgb(32 33 36 / 28%);display: flex;justify-content: space-between;align-items: center">
      <img src="../assets/qqqqqq.png" alt="天使针" title="天使针" style="width: 180px;height: 50px">
      <div style="padding:20px 20px" @click="show = true">
        <van-icon style="font-size: 32px" name="wap-nav"/>
      </div>
    </div>

    <van-popup v-model="show" position="right" :style="{ height: '100%',width:'80%' }" closeable
               close-icon-position="top-right">
      <div style="height: 100%;width: 100%">
        <div style="width: 100%">
          <img src="../assets/qqqqqq.png" alt="天使针" title="天使针" style="width: 180px;height: 50px">
        </div>
        <van-cell style="color: #00bef1" title="首页" is-link @click="reload"/>
        <van-cell title="授权医师/医院/运营中心/设计师查询" is-link @click="$router.push('/search')"/>
      </div>
    </van-popup>

    <div style="padding-top: 70px">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in imagesList" :key="index">
          <img :src="image.imageUrl" alt="天使针" title="天使针" width="100%"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--    &lt;!&ndash;    介绍&ndash;&gt;-->
    <!--    <div style=";width: 90%;margin: 20px auto 0">-->
    <!--      <h1 style="text-align: center;font-size: 30px;color:#323233">恒奥源医疗器械有限公司</h1>-->
    <!--      <p style="font-size: 18px;text-align: center;line-height: 200%;color:#6B7280">-->
    <!--        专注于医美医疗耗材销售、高端进口医疗美容设备运营、医美品项服务等领域。</p>-->
    <!--      <p style="font-size: 14px;line-height: 200%;color:#6B7280">-->
    <!--        恒奥源旗下业务：<br>-->
    <!--        轮廓材料—清秀线、天使针活性骨胶原支架植入材料<br>-->
    <!--        填充材料—天使针单相玻尿酸、稚龄童颜、塑欣玻尿酸<br>-->
    <!--        皮肤科材料—稚龄针<br>-->
    <!--        恒奥源医疗专注于医疗美容面部及身体年轻化版块。</p>-->
    <!--    </div>-->
    <!--    授权查询-->
    <div style="margin-top: 20px">
      <img src="../assets/ys.png" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '1'}})">
      <img src="../assets/yy.png" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '2'}})">
      <img src="../assets/sjs.png" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '4'}})">

      <img src="../assets/yyzx.png" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '3'}})">
      <!-- <img src="../assets/春天带.jpg" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '3'}})"> -->
      <!-- <img src="../assets/水晶线运营中心.jpg" alt="天使针" title="天使针" class="imgPX" @click="$router.push({ path: '/search', query: {type: '3'}})"> -->

    </div>
    <!--    产品-->
    <div style="margin-top: 20px">
      <!--      <img src="../assets/cp.jpg" class="imgPX">-->
      <img v-for="item in imagesList2" :src="item.imageUrl" alt="天使针" title="天使针" class="imgPX">
    </div>

    <div style="margin-top: 20px">

      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in imagesList3" :key="index">
          <img :src="image.imageUrl" alt="天使针" title="天使针" width="100%"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--    &lt;!&ndash;文献资料&ndash;&gt;-->
    <!--    <div style="margin-top: 20px">-->
    <!--      <img src="../assets/wd.jpg" class="imgPX">-->

    <!--    </div>-->
    <!--    &lt;!&ndash;    招商图加联系方&ndash;&gt;-->
    <!--    <div style="margin-top: 20px">-->
    <!--      <img src="../assets/zshz.png" class="imgPX">-->
    <!--      <img src="../assets/lxfs.jpg" class="imgPX">-->
    <!--    </div>-->
  </div>


</template>
<script>
import {baseUrl, queryByType} from "../http/APIConfig";
import img from '../assets/banner/1.png'
import img2 from '../assets/banner/2.png'
import img3 from '../assets/banner/3.png'

import a from '../assets/banner2/1.png'
import b from '../assets/banner2/2.png'
import c from '../assets/banner2/3.png'
import d from '../assets/banner2/4.png'

export default {

  data() {
    return {
      show: false,
      imagesList: [],
      imagesList2:[],
      imagesList3:[],
      images: [
        img,
        img2,
        img3
      ],

    };
  },

  methods: {

    reload() {
      window.location.reload()
    },
  },
  mounted() {
    queryByType(
        {
          // categoryType:1,
          type:0}
    ).then(res=>{
      res.rows.forEach(item=>{
        item.imageUrl = baseUrl+item.imageUrl
        if(item.categoryType ==1){
          this.imagesList.push(item)
          this.imagesList.sort((a, b) => a.sortNum - b.sortNum);
        }else if (item.categoryType ==2){
          this.imagesList2.push(item)
          this.imagesList2.sort((a, b) => a.sortNum - b.sortNum);
        }else {
          this.imagesList3.push(item)
          this.imagesList3.sort((a, b) => a.sortNum - b.sortNum);
        }
      })
    })
  }
};
</script>

<style lang="less">
.imgPX {
  width: 90%;
  margin: 10px auto;
  display: block;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}


</style>
